import React, { Dispatch, useEffect } from 'react';
import { AutoComplete, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../store/ducks/cidadeOrigem/actions';
import { Props } from './props';

const SelectCidade: React.FC<Props> = ({ setProps, name }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const cidade = useSelector((state: ApplicationState) => state.CidadeOrigem.data);
  const { Option } = AutoComplete;

  useEffect(() => {
    dispatch(loadRequest());
  }, [dispatch]);

  const handleSelect = (value: string, e: any) => {
    setProps(e);
  };
  return (
    <Form.Item label="" name={name} rules={[{ message: 'Selecione a cidade' }]}>
      <AutoComplete
        filterOption={(inputValue, option) =>
          option!.value?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
        }
        onChange={handleSelect}
        data-testid="select"
        placeholder="Selecione a cidade"
      >
        {cidade?.map((item: any) => (
          <Option data-testid="select-option" key={item.codCid} value={item.nome}>
            {item.nome}
          </Option>
        ))}
      </AutoComplete>
    </Form.Item>
  );
};

export default SelectCidade;
